import React, { useState } from 'react';
import { useUser } from '@clerk/clerk-react';

const CONTACT_METHODS = [
  'Phone',
  'Text',
  'Email',
  'CoreBids Chat',
  'Video Chat',
];
const TIMES = ['Morning', 'Afternoon', 'Evening'];

export default function CommunicationPreferenceTab() {
  const { user } = useUser();
  const privateMetadata = (user as unknown as { privateMetadata?: Record<string, unknown> })?.privateMetadata || {};
  const [form, setForm] = useState({
    preferredContactMethod: String(privateMetadata.preferredContactMethod || ''),
    bestTimeToContact: String(privateMetadata.bestTimeToContact || ''),
  });
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSave = async () => {
    if (!user) return;
    setSaving(true);
    await (user as unknown as { update: (arg: { privateMetadata: Record<string, unknown> }) => Promise<void> }).update({ privateMetadata: { ...privateMetadata, ...form } });
    setSaving(false);
    setSuccess(true);
    setTimeout(() => setSuccess(false), 2000);
  };

  return (
    <form style={{ maxWidth: 400, margin: '0 auto', display: 'flex', flexDirection: 'column', gap: 12 }}>
      <div>
        <label>Preferred Contact Method:</label>
        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
          {CONTACT_METHODS.map(method => (
            <label key={method} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
              <input
                type="radio"
                name="preferredContactMethod"
                value={method}
                checked={form.preferredContactMethod === method}
                onChange={handleChange}
              />
              {method}
            </label>
          ))}
        </div>
      </div>
      <select name="bestTimeToContact" value={form.bestTimeToContact} onChange={handleChange} required>
        <option value="">Best Time to Contact</option>
        {TIMES.map(time => <option key={time} value={time}>{time}</option>)}
      </select>
      <button type="button" onClick={handleSave} disabled={saving}>{saving ? 'Saving...' : 'Save'}</button>
      {success && <span style={{ color: 'green' }}>Saved!</span>}
    </form>
  );
} 